module.exports = __webpack_public_path__ + "static/media/expulsions.0ce10c5f.svg";